export default __webpack_public_path__ + "fonts/la-regular-400.eot";